import NoteAndDocument from "../../../../../../components/noteAndDocument/NoteAndDocument";
import { ExternalStorageNotesSectionProps } from "../externalStorage.types";

const ExternalStorageNotesSection = ({
  notesRef,
  parentId,
  disabled
}: ExternalStorageNotesSectionProps) => (
  <NoteAndDocument
    parentId={parentId}
    ref={notesRef}
    isDisabled={disabled}
    showSaveButton={false}
  />
);

export default ExternalStorageNotesSection;
